module.exports = __webpack_public_path__ + "static/zoom_zoomed-0a9f74f7e5977bbdec69157e8c0d23ec.jpg";